import type { Components } from "@mui/material";

export const MuiCheckboxThemeOptions: Components["MuiCheckbox"] = {
  defaultProps: {
    disableRipple: true,
    disableFocusRipple: true,
    disableTouchRipple: true,
  },
};
